module.exports = __webpack_public_path__ + "img/camp2.561b9811.jpg";